import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrl: './access-denied.component.scss',
    standalone: false
})
export class AccessDeniedComponent {

    constructor(private location: Location) { }

    goBack(): void {
        this.location.back();
    }
}
